var React = require('react');

function ChevronDownInline (props) {
    return React.createElement("svg",props,React.createElement("polyline",{"points":"6 9 12 15 18 9"}));
}

ChevronDownInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-chevron-down"};

module.exports = ChevronDownInline;

ChevronDownInline.default = ChevronDownInline;
